<template>
  <div style="max-width: 200px; line-height: 24px">
    <a-progress
      v-if="intPercent === 100"
      :percent="animPercent"
      :show-info="false"
    />
    <a-progress
      v-else
      :percent="animPercent"
      status="active"
      :show-info="false"
    />
    <div class="label">{{ label }}%</div>
  </div>
</template>

<script>
export default {
  props: ["percent", "label"],
  data() {
    return {
      animPercent: 0,
    };
  },
  computed: {
    intPercent() {
      return parseInt(this.percent);
    },
  },
  mounted() {
    setTimeout(() => {
      this.animPercent = this.intPercent;
    }, 100);
  },
};
</script>